import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Nav, HamburgerMenu, BtnSave } from './components'

import { loginUserCheck, logoutUser, userAddPoint } from '../redux/actions'

class AdminAddPoint extends Component {

    constructor() {
        super()
        this.state = {
            name: "",
            id: "",
            userid: "",
            type: "air",
            invoice: "",
            point: "",
            remark: "",
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
        const params = this.getParams(this.props.location)
        this.setState({
            id: params.id,
            userid: params.userid,
            name: params.name
        })
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.showAlert) {
            alert("This invoice is used.")
        }
    }

    getParams(location) {
        const searchParams = new URLSearchParams(location.search);
        return {
            id: searchParams.get('id') || '',
            userid: searchParams.get('userid') || '',
            name: searchParams.get('name') || ''
        };
    }

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    _handleLogout() {
        this.props.logoutUser()
    }

    _onHandleChange(event) {
		this.setState({
	    	[event.target.name]: event.target.value
	    });
    }

    _onSubmit() {
        let data = {
            userid: this.state.userid,
            type: this.state.type,
            invoice: this.state.invoice,
            point: Number(this.state.point),
            remark: this.state.remark,
            created_by: this.props.user
        }
        if(data.userid && data.type && data.invoice && data.point) {
            this.props.userAddPoint(this.state.id, data)
        } else {
            alert("Please fill in a form...")
        }
    }

    render() {
        if(!this.props.user) return  <div></div> 
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()} />
                <div className="admin-addpoint">
                    <Nav active="users"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>ลูกค้า : เพิ่มคะแนน</h2>
                            </div>
                            <div className="info">
                                <div className="profile">
                                    <h3 className="user-id">{this.state.userid}</h3>
                                    <h3>&nbsp;:&nbsp;</h3>
                                    <h3 className="username">{this.state.name}</h3>
                                </div>
                                <div className="adjust">
                                    <div className="type">
                                        <p>ประเภท</p>
                                        <select name="type" onChange={(event) => this._onHandleChange(event)}>
                                            <option value="air">แอร์</option>
                                            <option value="spare">อะไหล่</option>
                                        </select>
                                    </div>
                                    <div className="invoice">
                                        <form>
                                            <p>Invoice</p>
                                            <input type="text" name="invoice" onChange={(event) => this._onHandleChange(event)}></input>
                                        </form>
                                    </div>
                                    <div className="point">
                                        <form>
                                            <p>คะแนน</p>
                                            <input type="number" name="point" onChange={(event) => this._onHandleChange(event)}></input>
                                        </form>
                                    </div>
                                    <div className="remark">
                                        <form>
                                            <p>หมายเหตุ</p>
                                            <textarea name="remark" onChange={(event) => this._onHandleChange(event)}></textarea>
                                        </form>
                                    </div>
                                    <BtnSave click={() => this._onSubmit()}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth, user }) => {
    return { 
        user: auth.user,
        showAlert: user.showAlert
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, userAddPoint
})(AdminAddPoint);